import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDateRangePicker } from '@angular/material/datepicker';

@Component({
  selector: 'app-date-range-picker',
  templateUrl: './date-range-picker.component.html',
  styleUrls: ['./date-range-picker.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

/**
 * Date Range Picker Component
 */
export class DateRangePickerComponent {
  @ViewChild('rangePicker') rangePicker!: MatDateRangePicker<any>;
  @Output() dateRange = new EventEmitter<any>();
  @Input() rangeInMonths: number = 24;
  readonly range = new FormGroup({
    start: new FormControl<Date | null>(null),
    end: new FormControl<Date | null>(null),
  });

  maxDate: Date | undefined;

  /**
   * Opens the datepicker panel when the input area is clicked.
   */
  openDatepicker() {
    this.rangePicker.open();
  }

  /**
   * Emits click action event for underlying material button
   */
  emitDate() {
    this.dateRange.emit({
      start: this.range.get('start')?.value,
      end: this.range.get('end')?.value,
    });
  }

  /**
   * Sets max range
   * @return {Date}
   */
  setMaxRange(): Date | null {
    const minDate = this.range.get('start')?.value;

    if (!minDate) {
      return null;
    }

    this.maxDate = new Date(
      new Date(minDate).setMonth(
        new Date(minDate).getMonth() + this.rangeInMonths
      )
    );
    return this.maxDate;
  }
}
